module.exports = __webpack_public_path__ + "img/qrcode.fa26d7bb.jpg";